import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { detectbrowser } from 'src/app/utilities/utilities.file';
import { IwService } from 'src/app/services/iw.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ISTATACARD, PROGRESS_BAR } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @ViewChild('stickyPanel') stickeyElement: ElementRef;
  sticky = false;
  stickyForChrome = false;
  elementPosition: any;
  eapplyFormPostQDELabel: any;
  appCompleted : boolean = false;
  TATACARD = ISTATACARD;
  progress_text: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  
  constructor(
    private iw: IwService, 
    private sharedData: SharedServiceService,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    this.progress_text = PROGRESS_BAR;
    this.appCompleted=this.sharedData.appCompleted;
    console.log(detectbrowser().toLowerCase());
    this.eapplyFormPostQDELabel = this.iw.geteapplyFormPostQDEDCR();
  }

  ngAfterViewInit() {
    //this.elementPosition = this.stickeyElement.nativeElement.getBoundingClientRect().top; 
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    if(detectbrowser().toLowerCase().includes('chrome')){
      this.stickyForChrome=(window.pageYOffset >= this.elementPosition);
      this.sticky = false;
    }
    else{
      this.sticky = (window.pageYOffset >= this.elementPosition);
    }    
  }
}
